export interface ListResult<T> {
  items: T[];
  total: number;
  totalPages: number;
}

/**
 * Normalize a paginated list response. Tolerates several common envelope shapes:
 * { orders: [...], total, total_pages } | { data: [...], pagination: {...} } | [...]
 */
export function normalizeList<T>(raw: any, key: string, limit: number): ListResult<T> {
  const body = raw?.data !== undefined && !Array.isArray(raw?.data) && raw?.data?.[key] ? raw.data : raw;
  const items: T[] =
    (Array.isArray(body?.[key]) && body[key]) ||
    (Array.isArray(body?.data) && body.data) ||
    (Array.isArray(body?.items) && body.items) ||
    (Array.isArray(body) && body) ||
    [];
  const pagination = body?.pagination ?? {};
  const total: number = body?.total ?? pagination.total ?? items.length;
  const totalPages: number =
    body?.total_pages ??
    body?.pages ??
    pagination.total_pages ??
    pagination.pages ??
    Math.max(1, Math.ceil(total / limit));
  return { items, total, totalPages };
}
